module.exports = __webpack_public_path__ + "img/MdTitle.1415f006.png";